import { handleErrorWithSentry, replayIntegration } from '@sentry/sveltekit';
import * as Sentry from '@sentry/sveltekit';

Sentry.init({
	dsn: 'https://eef53fcd7417841b7250851fab16606a@o4506626963996672.ingest.us.sentry.io/4506626966814720',
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	integrations: [replayIntegration()],
	enabled: process.env.NODE_ENV !== 'development'
});

export const handleError = handleErrorWithSentry();
